import React from 'react';

// styles
import 'react-toastify/dist/ReactToastify.css';

// routes
import {Routes} from './routes';
import {BrowserRouter} from 'react-router-dom';

// components
import {ConfigLoader} from './shared/components';
import {ToastContainer} from 'react-toastify';

// providers
import AppProviders from './AppProviders';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

// Create a new QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // Never retry failed queries
    },
    mutations: {
      retry: 0, // Never retry failed mutations
    },
  },
});

/**
 * This is the main component of the application.
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigLoader>
        <AppProviders>
          <BrowserRouter>
            <Routes />
            <ToastContainer />
          </BrowserRouter>
        </AppProviders>
      </ConfigLoader>
    </QueryClientProvider>
  );
}

export default App;
